import balanceScale from "@/../../hypetrain/static/img/balance-scale.png";
import bullseye from "@/../../hypetrain/static/img/bullseye.png";
import achieve1 from "@/../../hypetrain/static/img/for-business/achieve1-1.png";
import achieve3 from "@/../../hypetrain/static/img/for-business/achieve1-3.png";
import shaneese from "@/../../hypetrain/static/img/shaneese.png";
import { SITE_NAME } from "@/css/constants";
import { MarketingPageBenefits, MarketingPageConfig } from "@/types/marketing";

import { CTAMini } from "./CTAMini";

const options: MarketingPageConfig = {
  page: "CAREER_COACHING",
  color: "#EA9924",
  metaTitle: `Online Career Coaching - ${SITE_NAME}`,
  metaDescription:
    "Build stronger relationships, learn how to influence your peers and executives, and even chart a path to your next promotion.",
  metaImage: "https://placement-pub.s3.us-east-2.amazonaws.com/career-meta.png",
  defaultHeadline: "Career Coaching",
  defaultSubHeader:
    "Meet 1:1 with a coach of your choice to move farther, faster on your career goals.",
  benefitsHeadline: "Get set up in no time",
  ctaText: "Grow faster with a coach",
  pricingIntro: "First session is only $29",
  audience: "D2C",
  serviceType: "session",
  specialtySlug: "career-coaching",
  FAQCategory: "Basics",
  marketingVideoId: 673995785,
  background:
    "linear-gradient(-25deg, rgb(194, 60, 255) 18%, rgb(117, 27, 177) 76%)",
  brandBg: "rgb(45, 8, 78)",
  heroGraphic: shaneese,
  heroGraphicWidth: "100%",
  playDark: false,
  pricingCTA: <CTAMini />,
  useCases: [
    "feedback",
    "imposter-syndrome",
    "manage-up",
    "conflict",
    "room-to-grow",
    "change-roles",
    "find-career",
    "quit-boss",
    "whats-next",
    "interviews",
    "go-remote",
    "new-industry",
    "more-money",
    "resume",
    "use-education",
    "find-mission",
  ],
  upsell: true,
};

const benefits: MarketingPageBenefits = {
  title: "Grow Your Career",
  subtitle: "Work with a coach to flourish in your career",
  items: [
    {
      title: "Accelerate Your Success",
      description: (
        <>
          Your coach can help you whether you're looking to make a career change
          or grow within your company.
        </>
      ),
      photo: achieve1,
      bgColor: "#FEF0ED",
    },
    {
      title: "Sharpen Your Focus",
      description: (
        <>
          Tame the mayhem and get clarity on the highest impact, high-priority
          uses of your time.
        </>
      ),
      photo: balanceScale,
      bgColor: "#FDF7E9",
    },
    {
      title: "Achieve Your Goals",
      description: (
        <>
          Discover your values, articulate your goals, and chart your course.
          With a coach, it's possible.
        </>
      ),
      photo: bullseye,
      bgColor: "#EBF3FD",
    },
    {
      title: "World-Leading Expertise",
      description: (
        <>
          You will overcome challenges by partnering with a certified coach with
          deep knowledge.
        </>
      ),
      photo: achieve3,
      bgColor: "#E9F7EF",
    },
  ],
};

export default {
  options,
  benefits,
};
